// @flow

export const SENTRY_DSN: string = process.env.REACT_APP_SENTRY_DSN
